import React from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  InputAdornment,
  IconButton,
  Typography
} from "@mui/material";
import buttonStyle from "../../../styles/buttonStyle";
import { useNavigate } from "react-router-dom";
import HeaderBox from "../../../components/HeaderBox";
import SingleAccordion from "../../../components/SingleAccordion";
import AddPartsTable from "../../../components/estimate/AddPartsTable";
import SearchIcon from "@mui/icons-material/Search";
import Complaint from "../../../components/enquiry/Complaint";

const boxStyle = {
  root: {
    backgroundColor: "white",
    borderRadius: "5px",
    padding: 1,
  },
};

function AddEstimate() {
  const navigate = useNavigate();
  // const [isParts, setIsParts] = useState(false);
  return (
    <Box mt={2}>
      <Grid container spacing={1}>
      <Grid item xs={12} >
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}> ADD ESTIMATE DETAILS</Typography>
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='flex-end' >
            <Button sx={buttonStyle.root} onClick={() => navigate("/Estimate_Bill")}> Save </Button>&nbsp;
            <Button sx={buttonStyle.root} onClick={() => navigate("/estimate")}> Cancel </Button>
          </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} mt={1}>
          <Box>
            <form>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <HeaderBox title="Estimate Details" />
                </Grid>
                <Grid item xs={12}>
                  <Box sx={boxStyle.root}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={6} md={4}>
                        <TextField fullWidth size="small" label="Search Enquiry Number" variant="outlined" required name="Search Enquiry Number"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment>
                                <IconButton>
                                  <SearchIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <TextField fullWidth size="small" label="Enquiry Date" variant="outlined" required name="enquiryDate"/>
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <TextField fullWidth size="small" label="Appoiment Date" variant="outlined" required name="Appoiment Date"/>
                      </Grid>
                      <Grid item xs={12} sm={6} md={2}>
                        <TextField fullWidth size="small" label="Total" variant="outlined" required name="Total "/>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <TextField fullWidth size="small" label="Estimate Number" variant="outlined" required name="estimateNo"/>
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <TextField fullWidth size="small" label="Estimate Date" variant="outlined" required name="estimateDate" />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <FormControl fullWidth size="small" required>
                          <InputLabel id="demo-simple-select-label"> Estimate Status </InputLabel>
                          <Select labelId="demo-simple-select-label" id="demo-simple-select" label="Estimate Status *">
                            <MenuItem value={10}>Estimate Process</MenuItem>
                            <MenuItem value={20}>Estimate Approval</MenuItem>
                            <MenuItem value={20}>Appointment Given</MenuItem>
                            <MenuItem value={20}>Rejected Estimate</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} md={2}>
                        <TextField fullWidth size="small" label="Total Parts" variant="outlined" required name="Total Parts"/>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <TextField fullWidth size="small" label="Registration Number" variant="outlined" required name="regiNum"/>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField fullWidth size="small" label="Vehicle Vin Number" variant="outlined" required name="vehicleMake"/>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField fullWidth size="small" label="Vehicle Description" variant="outlined" required name="vehicleDesc"/>
                      </Grid>
                      <Grid item xs={12} sm={6} md={2}>
                        <TextField fullWidth size="small" label="Total Labour" variant="outlined" required name="Total Labour" />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <HeaderBox title="Owner Details" />
                </Grid>
                <Grid item xs={12}>
                  <Box sx={boxStyle.root}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={6} md={5}>
                        <TextField fullWidth size="small" label="Owner Name" variant="outlined" required name="owner"/>
                      </Grid>
                      <Grid item xs={12} sm={6} md={5}>
                        <TextField fullWidth size="small" label="Street Name" variant="outlined" required name="street"/>
                      </Grid>
                      <Grid item xs={12} sm={6} md={2}>
                        <TextField fullWidth size="small" label="Postal Code" variant="outlined" required name="post"/>
                      </Grid>
                      <Grid item xs={12} sm={6} md={5}>
                        <TextField fullWidth size="small" label="Address" variant="outlined" required name="address"/>
                      </Grid>
                      <Grid item xs={12} sm={6} md={5}>
                        <TextField fullWidth size="small" label="Email ID" variant="outlined" required name="email"/>
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <TextField fullWidth size="small" label="Mobile" variant="outlined" required name="mobile"/>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                {/* <Grid item xs={12}>
                <HeaderBox title='PARTS' isOpen={isParts} setIsOpen={setIsParts}/>
              </Grid> */}
                <Grid item xs={12}>
                  <SingleAccordion component={<AddPartsTable />} title="Labour Tasks"/>
                </Grid>
                <Grid item xs={12}>
                  <SingleAccordion component={<AddPartsTable />} title=" Spare Parts"/>
                </Grid>
                <Grid item xs={12}>
                  <SingleAccordion component={<Complaint />} title="Suggestion"/>
                </Grid>
                {/* <Grid item xs={12}>
                  <SingleAccordion component={<Complaint />} title="Complaint"/>
                </Grid> */}
              </Grid>
            </form>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AddEstimate;
